<div class="skeleton" aria-busy="true" aria-label="Loading smart insights">
  <ngx-skeleton-loader
    class="skeleton__row"
    *ngFor="let row of rows; trackBy: trackByIndex"
    count="1"
    appearance="line"
    [theme]="rowTheme"
  ></ngx-skeleton-loader>
</div>
